import AddFaqForm from 'app/form/AddFaqForm';
// import TextEditor from 'app/form/TextEditor';
import React from 'react';

const AddFaq = () => {
	return (
		<div>
			<AddFaqForm />
			{/* <TextEditor /> */}
		</div>
	);
};

export default AddFaq;
